import phone from './phone.png';

const phoneNumbers = [
  {
    id: 1,
    image: phone,
    name: 'Аварийно-диспетчерская служба филиала МУП "МЩВ «Водоканал Пушкинского г.о.»',
    numbers: ['+7(496)532-55-93']
  },
  {
    id: 2,
    image: phone,
    name: 'Аварийно-диспетчерская служба Пушкинского филиала ООО «Газпром теплоэнерго МО»',
    numbers: ['+7(496)535-15-26']
  },
  {
    id: 3,
    image: phone,
    name: 'Аварийно-диспетчерская служба Северных сетей МОЭсК',
    numbers: ['+7(496)539-97-00', '+7(496)539-97-03']
  },
  {
    id: 4,
    image: phone,
    name: 'Центральная аварийно-диспетчерская служба',
    numbers: ['+7(496)532-59-28']
  },
  {
    id: 5,
    image: phone,
    name: 'МЧС',
    numbers: ['+7(496)537-14-01', '+7(496)532-15-54']
  },
  {
    id: 6,
    image: phone,
    name: 'Служба газового хозяйства',
    numbers: ['04', '+7(496)531-68-77']
  }
];

export default phoneNumbers;